import React from "react";
import { Link } from "gatsby";

class ProgramCard extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    console.log("componentDidMount called ");
  }
  render() {
    return (
      <div className="blog-card">
        <div className="blog-card__inner">
          <div className="blog-card__image">
            <img src={this.props.data.EventImagePath} width="375" height="275" alt="" />
            <div className="blog-card__date">{this.props.data.StartDate}</div>
          </div>
          <div className="blog-card__content mt-3">
            <h3>
              <Link to={this.props.toBaseUrl}
                state={{ id: this.props.data.EventsId }}>{this.props.data.EventTitle}</Link>
            </h3>
              <p><strong>Time:</strong> {this.props.data.TimeTxt}< br /><strong>Location:</strong> {this.props.data.EventLocation}</p>
            <Link className="blog-card__more" to={this.props.toBaseUrl}
              state={{ id: this.props.data.EventsId }}>
              <i className="far fa-angle-right"></i>Read More
            </Link>
          </div>
        </div>
      </div>
    );
  };
}

export default ProgramCard;
